/* IntelApps — Process Page */
import React, { useEffect } from 'react';
import Header from '../parts/Header.js';
import Footer from '../parts/Footer.js';
import ProcessSection from '../parts/Process.js';
import DiscussCTA from '../parts/Discuss.js';

export default function ProcessPage() {
  useEffect(() => { document.title = 'IntelApps — Process'; }, []);

  return (
    <>
      <Header />
      <main>
        <section className="page-hero">
          <div className="container page-hero-grid">
            <div>
              <span className="eyebrow">Process</span>
              <h1>Our Process</h1>
              <p className="page-hero-sub">A streamlined approach to delivering exceptional digital solutions on time and within budget.</p>
            </div>
          </div>
        </section>
        <ProcessSection />
        <DiscussCTA />
      </main>
      <Footer />
    </>
  );
}
